// removed by extract-text-webpack-plugin
module.exports = {"logos":"src-pages----about-module---logos---nQ2gY"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/about.module.scss
// module id = 453
// module chunks = 263791100135453